import { Block } from 'slate';

// eslint-disable-next-line
export function onClickColumnsBlock(event, type, editor) {
  event.preventDefault();
  const columnsNode = Block.create({
    object: 'block',
    type: 'columns',
    nodes: [
      {
        object: 'block',
        type: 'col',
        data: {
          width: '33.33%',
        },
        nodes: [
          {
            object: 'block',
            type: 'paragraph',
            nodes: [
              {
                object: 'text',
                text: '',
              },
            ],
          },
        ],
      },
      {
        object: 'block',
        type: 'col',
        data: {
          width: '33.33%',
        },
        nodes: [
          {
            object: 'block',
            type: 'paragraph',
            nodes: [
              {
                object: 'text',
                text: '',
              },
            ],
          },
        ],
      },
      {
        object: 'block',
        type: 'col',
        nodes: [
          {
            object: 'block',
            type: 'paragraph',
            nodes: [
              {
                object: 'text',
                text: '',
              },
            ],
          },
        ],
      },
    ],
  });


  editor.insertBlock(columnsNode);
}
